
export class ExitInterviews {
  Id: number;
  OffboardingId: number;
  EmpCode: number;
  Question: string;
  EmployeeComments: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string; 
  ModifiedDate: Date;
  isEditing?: boolean;
  SortOrder?: number;
  ExitInterviewHRComments: string;
  IsEmpFeedbackSubmitted: boolean;
  IsEmpFeedbackRequired?: boolean;
  IsHRCommentsSubmitted?: boolean;
  IsRejected?: boolean;
}

export interface ExitInterviewResponses {
  responses: ExitInterviews[];
  IsEmpFeedbackSubmitted?: boolean;
}


